module.exports = __webpack_public_path__ + "static/media/chat.bccf60b7.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_130/image/chat.png
// module id = 1182
// module chunks = 0